import { z } from 'zod';

// form validation rules
export const AddressSchema = z.object({
  line_one: z.string().optional(),
  line_two: z.string().optional(),
  city: z.string().optional(),
  state: z.string().optional(),
  zipcode: z.string().optional(),
  country: z.string().optional(),
});

export type Address = z.infer<typeof AddressSchema>;
